import React, { memo, useEffect, useRef } from 'react'
import moment from 'moment'
import * as R from 'ramda'
import cx from 'classnames'
import ImageArea from '~/components/ImageArea'
import { universalOpenUrl, onShowedOnce, sendTrack, trackSugar } from '~/utils'
import styles from './index.css'

const WEAL_STATUS = {
  1: '待启动',
  2: '进行中',
  3: '已结束',
}

const Activity = memo(({ item, wealTypes, index }) => {
  const { id, imageUrl, targetUrl } = item
  const clickUrlBatch = R.pathOr([], ['clickUrlBatch'], item)
  const exposureUrlBatch = R.pathOr([], ['exposureUrlBatch'], item)
  const ref = useRef(null)

  useEffect(() => {
    onShowedOnce(ref.current, () => {
      trackSugar({
        md: 2,
        cti: id,
        pi: index,
        cu: imageUrl,
        at: 'view',
        et: 'card_show',
        ct: 'custom',
        eu: targetUrl,
      })
      if (!exposureUrlBatch.length) return
      exposureUrlBatch.forEach(sendTrack)
    })
  }, [])

  const handleItemClick = url => () => {
    if (clickUrlBatch.length) {
      clickUrlBatch.forEach(sendTrack)
    }
    trackSugar({
      md: 2,
      cti: id,
      pi: index,
      cu: imageUrl,
      at: 'click',
      et: 'card_click',
      ct: 'custom',
      eu: targetUrl,
    })
    universalOpenUrl(url)
  }

  return (
    <div
      className={styles.hotActivityItem}
      onClick={handleItemClick(item.targetUrl)}
      ref={ref}
    >
      <ImageArea className={styles.activityImage} src={item.imageUrl}>
        <div
          className={cx(styles.hotActivityItemStatus, {
            [styles.hotActivityItemStatusInactive]: false,
          })}
        >
          {WEAL_STATUS[item.wealStatus]}
        </div>
      </ImageArea>
      <p className={styles.activityTitle}>{item.wealName}</p>
      <p className={styles.activityTime}>
        {moment(item.startTime).format('MM月DD日')}
        -
        {moment(item.endTime).format('MM月DD日')}
      </p>
      {wealTypes[item.type] && (
        <div className={styles.activityType}>
          <span>{wealTypes[item.type]}</span>
        </div>
      )}
    </div>
  )
})

export default Activity



// WEBPACK FOOTER //
// ./src/pages/Home/activity.js